"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const Styles = {
    manageAccountsTable: (isFilterOpen) => core_1.css `
    height: ${isFilterOpen ? '60.5%' : '75%'}
  `,
};
exports.default = Styles;
